import { ConsentService } from './consent.service'

export const consentService = new ConsentService(__CONSENT_CONFIG__)
export * from './constants'



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/index.js